export default __webpack_public_path__ + "static/media/TZ.8dbfdde9.svg";